































































import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import { LibraryItem } from '@/interfaces/world/library';
import FirebaseGateway from '@/classes/firebaseGateway';

@Component
export default class Library extends Vue {

  private categories = [
    { value: 'rules', text: 'Regeln'},
    { value: 'world', text: 'Welt'},
    { value: 'misc', text: 'Sonstiges'},
  ];

  private showCreateDialog = false;

  private uploading = false;

  private selectedFile: File | null = null;

  private uploadError: string | null = null;
  private error: string | null = null;

  private newLibraryItem: LibraryItem = {
    id: null,
    title: '',
    description: '',
    filename: '',
    thumbnailUrl: null,
    size: 0,
    category: '',
  };

  private isDownloadingId: string | null = null;

  get items(): LibraryItem[] {
    return this.$store.getters.library;
  }

  get currentWorld() {
    return this.$store.getters.currentWorld;
  }

  public mounted() {
    this.$store.dispatch('loadLibrary');
  }

  private getItemsByCategory(category: string) {
    return this.items
      .filter((libraryItem) => libraryItem.category === category)
      .sort((itemA, itemB) => itemA.title < itemB.title ? -1 : 1);
  }

  private uploadLibraryItem() {
    if (this.selectedFile === null) {
      throw new Error('Cannot upload, no file selected');
    }

    this.uploading = true;
    this.newLibraryItem.filename = this.selectedFile.name;
    this.newLibraryItem.size = this.selectedFile.size;
    new FirebaseGateway().uploadFile(this.selectedFile, '/worlds/' + this.currentWorld + '/library/', true)
    .then((uploadTaskSnapshot) => {
      this.$store.dispatch('createLibraryItem', this.newLibraryItem)
      .then(() => {
        this.uploading = false;

        this.resetDialog();
      })
      .catch((error) => {
        this.uploading = false;
        this.uploadError = error;
      });

    })
    .catch((error) => {
      if (error instanceof Error && error.message === 'file_exists') {
        this.uploadError = 'Datei mit diesem Namen existiert bereits';
      } else {
        this.uploadError = error;
      }
      this.uploading = false;
    });

  }

  private downloadItem(libraryItem: LibraryItem) {
    this.error = null;
    this.isDownloadingId = libraryItem.id;
    this.$store.dispatch('loadLibraryItemUrl', libraryItem.filename).then((url) => {
      window.open(url);
    })
    .catch((error) => {
      this.error = error;
    })
    .finally(() => {
      this.isDownloadingId = null;
    });
  }

  private resetDialog() {
    // Hide dialog
    this.showCreateDialog = false;

    // Reset item
    this.newLibraryItem = {
      id: null,
      title: '',
      description: '',
      filename: '',
      thumbnailUrl: null,
      size: 0,
      category: '',
    };

    // Clear selected file
    this.selectedFile = null;
  }
}
